import React from 'react';
import { FormattedMessage } from 'react-intl';
import useActivityDuration from 'hooks/useActivityDuration';
import { Track } from 'types/Trails/Track';
import Trail from 'types/Trails/Trail';
import { MapStatsUtil } from 'utils/map_stats_util';

type Props = {
  record: Trail | Track;
  isEstimate?: boolean;
};

const CardDuration = ({ record, isEstimate }: Props) => {
  const durationMinutes = useActivityDuration(record);

  if (!durationMinutes) {
    return null;
  }

  let className = 'xlate-none';
  const hours = Math.floor(durationMinutes / 60);

  if (hours >= 12) {
    // "Multi-day" can be translated while "4 h 38 m" cannot
    className = null;
  }

  const estimateText = isEstimate ? <FormattedMessage defaultMessage="Est." /> : '';

  return (
    <>
      <span>&nbsp;•&nbsp;</span>
      <span className={className}>
        {estimateText}
        &nbsp;
        {MapStatsUtil.minutesToFormattedTime(durationMinutes)}
      </span>
    </>
  );
};

export default CardDuration;
